module.exports = __webpack_public_path__ + "static/media/logo_b.fffbf49e.svg";